import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { getMisFichajesValidacion } from "../../api/api";

export default function FichajesOfflineStatus() {
  const { token } = useContext(AuthContext);
  const [fichajes, setFichajes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    cargarFichajes();
  }, []);

  const cargarFichajes = async () => {
    try {
      setLoading(true);
      const data = await getMisFichajesValidacion(token);
      // Mostrar solo pendientes (validado === null) y rechazados (validado === false)
      const relevantes = data.filter(f => f.validado === null || f.validado === false);
      setFichajes(relevantes);
    } catch (error) {
      console.error("Error al cargar fichajes de validación:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatearFecha = (fecha) => {
    return new Date(fecha).toLocaleString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <p className="text-gray-500 text-sm">Cargando...</p>
      </div>
    );
  }

  if (fichajes.length === 0) return null;

  return (
    <div className="mb-4">
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="px-4 py-3 border-b border-gray-100">
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide flex items-center gap-2">
            <i className="fas fa-wifi-slash text-gray-400"></i>
            Fichajes offline — validación pendiente
          </h3>
        </div>
        <div className="p-4 space-y-3">
          {fichajes.map((f) => (
            <div
              key={f._id}
              className={`border rounded-lg p-3 ${
                f.validado === null
                  ? "border-yellow-300 bg-yellow-50"
                  : "border-red-300 bg-red-50"
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <i
                    className={`fas ${
                      f.tipo === "entrada" ? "fa-sign-in-alt text-green-600" : "fa-sign-out-alt text-red-600"
                    }`}
                  ></i>
                  <span className="font-medium text-sm text-gray-800">
                    {f.tipo === "entrada" ? "Entrada" : "Salida"}
                  </span>
                  <span className="text-sm text-gray-600">
                    {formatearFecha(f.fecha)}
                  </span>
                </div>
                <span
                  className={`px-2 py-1 rounded-full text-xs font-semibold ${
                    f.validado === null
                      ? "bg-yellow-100 text-yellow-800"
                      : "bg-red-100 text-red-800"
                  }`}
                >
                  {f.validado === null ? "Pendiente" : "No validado"}
                </span>
              </div>
              {f.notasValidacion && (
                <p className="text-xs text-gray-600 mt-2">
                  <strong>Motivo:</strong> {f.notasValidacion}
                </p>
              )}
              {f.timeDifferenceMinutes && (
                <p className="text-xs text-gray-500 mt-1">
                  Diferencia horaria: {Math.round(f.timeDifferenceMinutes)} min
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
